import { Sigma, Atom } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const LEVELS = [
    { n: "I", label: "Medie", desc: "Equazioni, geometria, proporzioni. Le basi che poi fanno la differenza." },
    { n: "II", label: "Superiori", desc: "Analisi, funzioni, meccanica, elettromagnetismo. Verifiche ed esame di maturità." },
];

const Subjects = () => (
    <section id="materie" className="relative py-32 sm:py-40 border-t border-slate-800">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
            <SectionHeading
                index="02"
                label="Cosa insegniamo"
                title={
                    <>
                        Solo due materie. <em className="text-sky-400">Fatte bene.</em>
                    </>
                }
            />

            <div className="mt-16 grid md:grid-cols-2 gap-8 lg:gap-12">
                <Reveal>
                    <div data-testid="subject-card-matematica" className="group h-full border border-slate-800 bg-[#0F172A]/40 p-10 hover:border-sky-400/60 transition-colors duration-500">
                        <Sigma size={36} className="text-sky-400" strokeWidth={1.5} />
                        <h3 className="mt-6 font-serif text-3xl sm:text-4xl text-slate-50">Matematica</h3>
                        <ul className="mt-6 space-y-3 font-mono text-sm text-slate-400">
                            {["Aritmetica e problemi", "Algebra ed equazioni", "Geometria e goniometria", "Funzioni e analisi", "Probabilità e statistica", "…ecc."].map((item) => (
                                <li key={item} className="flex items-center gap-3 border-b border-slate-800/70 pb-3">
                                    <span className="text-sky-400">→</span> {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
                <Reveal delay={0.15}>
                    <div data-testid="subject-card-fisica" className="group h-full border border-slate-800 bg-[#0F172A]/40 p-10 hover:border-sky-400/60 transition-colors duration-500">
                        <Atom size={36} className="text-sky-400" strokeWidth={1.5} />
                        <h3 className="mt-6 font-serif text-3xl sm:text-4xl text-slate-50">Fisica</h3>
                        <ul className="mt-6 space-y-3 font-mono text-sm text-slate-400">
                            {["Grandezze e unità di misura", "Moto, forze ed energia", "Termodinamica", "Elettricità e magnetismo", "Onde e ottica", "…ecc."].map((item) => (
                                <li key={item} className="flex items-center gap-3 border-b border-slate-800/70 pb-3">
                                    <span className="text-sky-400">→</span> {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.2}>
                <p data-testid="subjects-note" className="mt-10 max-w-3xl text-slate-300 leading-relaxed border-l-2 border-sky-400 pl-6">
                    In breve: <span className="text-slate-50 font-semibold">se è nel tuo programma, lo insegniamo.</span> Qualsiasi
                    argomento di matematica e fisica, dalle medie fino all'ultimo anno
                    di superiori.
                </p>
            </Reveal>

            <div className="mt-8 grid sm:grid-cols-2 gap-8 lg:gap-12">
                {LEVELS.map((l, i) => (
                    <Reveal key={l.n} delay={0.1 + i * 0.1}>
                        <div data-testid={`level-card-${i}`} className="border border-slate-800 p-8 hover:bg-[#0F172A]/60 transition-colors duration-500">
                            <span className="font-mono text-4xl text-sky-400/80">{l.n}</span>
                            <h4 className="mt-4 font-serif text-2xl text-slate-50">{l.label}</h4>
                            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{l.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
export default Subjects;
